import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ltlwh1w: FaireBrandEntity = {
  token: "b_7ltlwh1w",
  type: "brand",
  name: "True Hue",
  avatarUrl:
    "https://cdn.faire.com/fastly/ad17c0fb719307a70fbb5ab49e9e6ef181426ffb4d8337c2b0623af0c591ea8a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f78f9fed4a61236764765e8f4c1560d44e34c7cfbbff2c71adf726c71e1ab72c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ad17c0fb719307a70fbb5ab49e9e6ef181426ffb4d8337c2b0623af0c591ea8a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f78f9fed4a61236764765e8f4c1560d44e34c7cfbbff2c71adf726c71e1ab72c.jpeg",
  location: "Minneapolis, MN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 174,
  isTopShop: true,
  isInsider: true,
  description:
    "At True Hue, we believe every scent is a portal - a passage to moments of beauty, poetry, and wonder. With our signature moody, modern, and magical fragrances, we don't just create scents; we craft experiences that spark connection and inspire the soul. Each scent tells a story, whisking you away to misty forests, sun-kissed lakes, and moonlit dance floors. It's not just about a fragrance - it's about how it makes you feel, how it ties to your own story, and how it helps create new memories.\n\nFounded in 2017 by Griffin Overbye in Minneapolis, True Hue began as a passion project in a college apartment, driven by a dream to bottle the magic of nature. From those early days to our thriving warehouse today, we've stayed rooted in sustainability, craftsmanship, and community. Our candles, sprays, and diffusers are crafted with precision and care, using a luxurious soy coconut wax blend and phthalate-free oils to ensure a product that's both eco-conscious and indulgent. \n\nWe support causes that foster inclusion, so when you choose True Hue, you're making a positive impact. Each scent invites you to pause and reconnect, bringing the essence of nature right into your home.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:55.343Z",
    importedBy: "entity-db-cli",
  },
};
